import React from 'react';
import PropTypes from 'prop-types';
import MobileNavigationVerticalLink from './MobileNavigationVerticalLink';

const MobileNavigationVerticalList = ({ pages }) => {
  if (!Array.isArray(pages)) {
    return null;
  }

  return (
    <ul className="mobile-navigation__list mobile-navigation-vertical__list">
      {
        pages.map(({
          slug,
          name,
          url,
          pages: nestedPages,
          openInNewWindow,
          additionalClass,
          additionalId,
        }) => (
          <li key={slug} data-test="mobile-navigation-vertical-list">
            <MobileNavigationVerticalLink
              name={name}
              pages={nestedPages}
              url={url}
              openInNewWindow={openInNewWindow}
              textExtraClass={additionalClass}
              textExtraId={additionalId}
            />
          </li>
        ))
      }
    </ul>
  );
};

MobileNavigationVerticalList.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    pages: PropTypes.array,
    openInNewWindow: PropTypes.bool,
  })),
};

export default MobileNavigationVerticalList;
